import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@do/ui/components/select";
import { cn } from "@do/ui/lib/utils";
import { EarthIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import React from "react";
import { LOCALES } from "../../../constants";
import { useChat } from "../../../providers/chat-provider";
import { HeaderSettingsSection } from "./section";

export const HeaderSettingsLanguage = () => {
  const { chatbotParams, currentLocale, onChangeLocale } = useChat();
  const t = useTranslations("do-chat-v2");

  return (
    <HeaderSettingsSection
      id="language"
      title={t("chat.header.settings.language.title")}
      description={t("chat.header.settings.language.description")}
      icon={EarthIcon}
    >
      <Select value={currentLocale ?? undefined} onValueChange={onChangeLocale}>
        <SelectTrigger
          id="header-settings-dialog-content-section-language-select"
          aria-labelledby="header-settings-dialog-content-section-language-title"
          className={cn(
            "w-(--header-settings-dialog-content-section-language-select-width)",
            "h-(--header-settings-dialog-content-section-language-select-height)!",
            "px-(--header-settings-dialog-content-section-language-select-padding-x)",
            "rounded-(--header-settings-dialog-content-section-language-select-border-radius)",
            "bg-(--header-settings-dialog-content-section-language-select-background)/(--header-settings-dialog-content-section-language-select-background-opacity)",
            "text-(--header-settings-dialog-content-section-language-select-foreground)/(--header-settings-dialog-content-section-language-select-foreground-opacity)",
            "hover:bg-(--header-settings-dialog-content-section-language-select-hover-background)/(--header-settings-dialog-content-section-language-select-hover-background-opacity)",
            "hover:text-(--header-settings-dialog-content-section-language-select-hover-foreground)/(--header-settings-dialog-content-section-language-select-hover-foreground-opacity)",
            "focus-visible:bg-(--header-settings-dialog-content-section-language-select-focus-background)/(--header-settings-dialog-content-section-language-select-focus-background-opacity)",
            "focus-visible:text-(--header-settings-dialog-content-section-language-select-focus-foreground)/(--header-settings-dialog-content-section-language-select-focus-foreground-opacity)",
            "border-(length:--header-settings-dialog-content-section-language-select-border-width)",
            "border-(--header-settings-dialog-content-section-language-select-border-color)/(--header-settings-dialog-content-section-language-select-border-opacity)",
            "hover:border-(--header-settings-dialog-content-section-language-select-hover-border-color)/(--header-settings-dialog-content-section-language-select-hover-border-opacity)",
            "focus-visible:border-(--header-settings-dialog-content-section-language-select-focus-border-color)/(--header-settings-dialog-content-section-language-select-focus-border-opacity)",
            "focus-visible:ring-(--header-settings-dialog-content-section-language-select-focus-ring-color)/(--header-settings-dialog-content-section-language-select-focus-ring-opacity)",
            "focus-visible:ring-(length:--header-settings-dialog-content-section-language-select-focus-ring-width)",
            "focus-visible:ring-offset-(length:--header-settings-dialog-content-section-language-select-focus-ring-offset-width)",
            "[box-shadow:var(--header-settings-dialog-content-section-language-select-box-shadow)]"
          )}
        >
          <SelectValue
            id="header-settings-dialog-content-section-language-select-value"
            placeholder={t("chat.header.settings.language.placeholder")}
          />
        </SelectTrigger>
        <SelectContent id="header-settings-dialog-content-section-language-select-content">
          {Object.keys(chatbotParams.availableLocales || {}).map((locale) => {
            const localeCode = locale.slice(0, 2);
            const Flag = LOCALES.find((l) => l.code === localeCode)?.flag ?? React.Fragment;

            return (
              <SelectItem
                id={`header-settings-dialog-content-section-language-select-item-${localeCode}`}
                key={locale}
                value={locale}
              >
                <Flag aria-hidden="true" />{" "}
                {t(`chat.header.settings.language.locales.${localeCode}`)}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </HeaderSettingsSection>
  );
};
